window.EF = require('ef/ef');
require('ef-requires');

var ContentService = require('services/content-service');
var CourseSettingsService = require('services/course-settings-service');
var LocaleService = require('services/locale-service');
var AudioService = require('services/audio-service');
var PortfolioService = require('services/portfolio-service');
var NavigationService = require('services/navigation-service');
var SurveyService = require('services/survey-service');
var SyncService = require('services/sync-service');
var AssessmentService = require('services/assessment-service');
var EvaluationService = require('services/evaluation-service');
import IconLoadService from 'services/icon-load-service';
import LearnerProfileService from 'services/learner-profile-service';
import { timerService } from 'services/timer-service';
import CourseTimerService from 'services/timer/course-timer-service';

var utils = require('lib/utils');

export default Chaplin.Application.extend({
  title: 'EverFi SDK',
  initialize: function (options) {
    const params = new URLSearchParams(window.location.search);
    const urlOptions = params.get('options') ? JSON.parse(atob(params.get('options'))) : {};
    _.defaultsDeep(options, urlOptions, utils.tryRequire('local-data/config.json'), {
      config: {
        settings: {
          local: true,
          env: 'dev',
        },
        enrollment: {
          id: 1,
          name: 'Charles Xavier',
          schoolName: 'EverFi Institute',
          className: 'Spring 2013',
          certified: false,
          autoPlay: false,
        },
        i18n: {},
      },
    });
    // HR config passed here
    this.config = options.config;
    if (this.config.i18n.lngs) {
      this.config.settings.available_languages = this.config.i18n.lngs;
    }
    if (window.location.search.indexOf('setLng') >= 0) {
      this.config.i18n.lng = null;
    }
    // if the config decides to send the app elsewhere replace the hash now
    // this prevents the router from routing to the menu and then to the page
    // if the menu was loaded and then quickly switched to another page
    // the menu would dispose itself before it was done loading and cause some undefined errors
    if (this.config && this.config.other && this.config.other.start) {
      window.location.replace(`#${this.config.other.start}`);
    }

    utils.initialize(this.config.settings);
    NavigationService.initialize(this.config.settings);
    Chaplin.Application.prototype.initialize.apply(this, arguments);
  },
  start: function () {
    var self = this;
    this.setCSRFToken();
    CourseSettingsService.initialize(this.config.settings).then(function () {
      Promise.all([ContentService.initialize(), LocaleService.initialize(self.config.i18n)])
        .then(function () {
          var groupsJson = ContentService.groups;
          var modulesJson = ContentService.modules;
          var modulesContentJson = ContentService.moduleContent;
          var enrollment = self.config.enrollment;

          EF.init(
            groupsJson,
            modulesJson,
            modulesContentJson,
            enrollment,
            {
              local: self.config.settings.local,
              apiOnly: true,
              autoNextActivity: true,
              loadActivityProgresses: self.config.settings.progressProvider !== 'content-service',
              evaluations: self.config.evaluations,
            },
            self.config.settings
          );
          AudioService.initialize();
          SurveyService.initialize(self.config.surveys);
          AssessmentService.initialize(self.config.assessments);
          EvaluationService.initialize(self.config.evaluations);
          LearnerProfileService.initialize(self.config.learnerProfile);

          window.addEventListener(
            'message',
            event => {
              if (event.data.event_type === 'reload-evaluation') {
                EvaluationService.updateResponseSet(event.data.slug, event.data.response_set);
              }
            },
            false
          );
        })
        .catch(function () {
          // eslint-disable-next-line no-console
          console.log('Content Loading Failed! Maybe you have an error in your JSON?');
        });
    });

    if (this.config.settings.local) {
      SyncService.initialize(this.config.settings);
    }

    EF.on('ready', () => {
      var args = Array.prototype.slice.call(arguments);
      if (CourseSettingsService.get('portfolio')) {
        PortfolioService.initialize();
      }
      if (EF.options.local) {
        EF.activityProgresses.fetch();
        EF.customizations.fetch();
      }

      let customModules = EF.customizations.get('content-module-customization');
      if (!customModules && this.config.settings.module_keys) {
        const attributes = Object.assign(
          { customization_type: 'content-module-customization' },
          this.config.settings.module_keys
        );
        const options = { enrollment: this.config.enrollment };
        customModules = new EF.Models.Customization(attributes, options);
        EF.customizations.add(customModules);
      }
      if (customModules) {
        var newModules = EF.modules.filter(mod => customModules.get('modules').indexOf(mod.get('key')) > -1);
        customModules.get('modules').forEach((mod, i) => {
          const module = EF.modules.find({ key: mod });
          if (module) {
            module.set('index', i);
          } else {
            // eslint-disable-next-line no-console
            console.log(`couldn't find module with key ${mod} in `, EF.modules);
          }
        });
        EF.modules = new EF.Collections.ModulesCollection(newModules);
        EF.modules.sort();
        customModules.set('force_order', customModules.get('force_order') == 'true');
        EF.groups.each(g => {
          g.modules.sort();
          g.modules.forEach(m => {
            if (m && m.get('key') !== undefined && EF.modules.find({ key: m.get('key') }) === undefined) {
              // Inconsistency, this module is in groups but not in EF.modules
              // Get rid of it so it doesn't get in the way of unlocking the next module
              g.modules.remove(m);
            }
          });
          if (g.get('custom_in_order')) {
            g.set('in_order', customModules.get('force_order'));
          }
        });
      }

      Chaplin.Application.prototype.start.apply(this, args);
      if (CourseSettingsService.get('startupScript')) {
        require(CourseSettingsService.get('startupScript'));
      }
      if (CourseSettingsService.get('menu') && CourseSettingsService.get('menu').skip && !window.location.hash) {
        var firstIncomplete = EF.modules.getFirstAvailable(CourseSettingsService.get('menu'));
        if (!firstIncomplete) {
          firstIncomplete = EF.modules.first();
        }
        this.router.route({ url: firstIncomplete.get('key') }, { replace: true });
      }

      // Register hbs partials
      this.registerPartials();

      IconLoadService.configFontAwesome({
        autoReplaceSvg: false,
        observeMutations: false,
        showMissingIcons: false,
      });

      EF.timerService = timerService;
      EF.courseTimerService = CourseTimerService.initialize();
      // self.onWindowFocusChange((visible) => {
      //   if(EF.courseTimerService) {
      //     if(visible) {
      //       if(EF.courseTimerService.courseCountdownTimer) {
      //         EF.courseTimerService.courseCountdownTimer.resume();
      //       }
      //       if(EF.courseTimerService.courseTimer) {
      //         EF.courseTimerService.courseTimer.resume();
      //       }
      //     } else {
      //       if(EF.courseTimerService.courseCountdownTimer) {
      //         EF.courseTimerService.courseCountdownTimer.stop();
      //       }
      //       if(EF.courseTimerService.courseTimer) {
      //         EF.courseTimerService.courseTimer.stop();
      //       }
      //     }
      //   }
      // });
    });

    this.router.subscribeEvent('router:match', this.trackPageView);
    this.router.subscribeEvent('router:match', this.postMessageNewUrl);
  },
  trackPageView: function (route) {
    if (window.ga && typeof window.ga.getAll === 'function') {
      var url = location.pathname + '#' + route.path;
      window.ga.getAll().forEach(tracker => {
        tracker.send('pageview', url.replace(/^!/, ''));
      });
    }
  },
  postMessageNewUrl(route) {
    window.postMessage(
      {
        event_type: 'url-change',
        new_url: `${location.origin}/${location.pathname}#${route.path}`,
      },
      window.location.origin
    );
  },
  registerPartials() {
    window.require
      .list()
      .filter(m => m.includes('views/partials'))
      .forEach(path => {
        Handlebars.registerPartial(path.replace(/^.*[\/]/, ''), require(path));
      });
  },
  setCSRFToken: function () {
    let funcs = {
      csrfToken: function () {
        return $('meta[name=csrf-token]').attr('content');
      },

      // Make sure that every Ajax request sends the CSRF token
      CSRFProtection: function (xhr) {
        var token = funcs.csrfToken();
        if (token) xhr.setRequestHeader('X-CSRF-Token', token);
      },
    };

    $.ajaxPrefilter(function (options, originalOptions, xhr) {
      if (!options.crossDomain) {
        funcs.CSRFProtection(xhr);
      }
    });
  },
  // listens for window focus changing
  // if activeElement is an iframe, it'll treat the window like it has focus
  onWindowFocusChange(callback) {
    let visible = true;

    const focused = () => {
      if (!visible) {
        callback((visible = true));
      }
    };
    const unfocused = () => {
      if (visible) {
        callback((visible = false));
      }
    };
    if (window.document.activeElement) {
      if (window.document.activeElement.tagName.toLowerCase() === 'iframe') {
        focused;
      }
    }
    if ('hidden' in document) {
      document.addEventListener('visibilitychange', () => {
        document.hidden ? unfocused : focused;
      });
    }
    if ('mozHidden' in document) {
      document.addEventListener('mozvisibilitychange', () => {
        document.mozHidden ? unfocused : focused;
      });
    }
    if ('webkitHidden' in document) {
      document.addEventListener('webkitvisibilitychange', () => {
        document.webkitHidden ? unfocused : focused;
      });
    }
    if ('msHidden' in document) {
      document.addEventListener('msvisibilitychange', () => {
        document.msHidden ? unfocused : focused;
      });
    }
    // IE 9 and lower:
    if ('onfocusin' in document) {
      document.onfocusin = focused;
      document.onfocusout = unfocused;
    }
    // All others:
    window.onpageshow = window.onfocus = focused;
    window.onpagehide = window.onblur = unfocused;
  },
});
